import { render, staticRenderFns } from "./Inadimplentes.vue?vue&type=template&id=7f0a677b&scoped=true"
import script from "./Inadimplentes.vue?vue&type=script&lang=js"
export * from "./Inadimplentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a677b",
  null
  
)

export default component.exports